var CompositeParams_1, CompositeSignatureValue_1;
import { __decorate } from "tslib";
import { AsnArray, AsnPropTypes, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { AlgorithmIdentifier } from "@peculiar/asn1-x509";
export const id_alg_composite = "1.3.6.1.4.1.18227.2.1";
let CompositeParams = CompositeParams_1 = class CompositeParams extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, CompositeParams_1.prototype);
    }
};
CompositeParams = CompositeParams_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: AlgorithmIdentifier })
], CompositeParams);
export { CompositeParams };
let CompositeSignatureValue = CompositeSignatureValue_1 = class CompositeSignatureValue extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, CompositeSignatureValue_1.prototype);
    }
};
CompositeSignatureValue = CompositeSignatureValue_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.BitString })
], CompositeSignatureValue);
export { CompositeSignatureValue };
